module.exports = __webpack_public_path__ + "assets/images/project/nongsa-desktop.jpg?v=e8d1d88a";